<script>
  import SideGroup from '/Groups/SideGroup'
  import CardMainContent from '/Widgets/CardMainContent'
  import CardArtists from '/Widgets/CardArtists'
  import CardProjectEvent from '/components/Widgets/CardProjectEvent.svelte'
  import Related from '/Groups/Related'
  import Body from '/Groups/Body'
  import EventDate from '/Atoms/EventDate'

  import { sortEvents } from '/helper'

  export let data

  let project = data?.Project || {}

  let body = project?.body || []

  const teaser = project?.teaser
  const title = project?.title
  const startDate = project?.eventDates?.[0]?.startDateAndTime
  const endDate = project?.eventDates?.[0]?.endDateAndTime
  const dateDisplay = project?.dateDisplay

  // parent project for the link back
  const parentProject = project?.relatedProjects?.[0]
  const category = parentProject ? parentProject.title : null
  const category_link = parentProject ? { slug:parentProject.slug, section: "projects"} : null

  // projects can have special collections
  const projectCollection = project?.projectItems?.[0]?.collection || []

  // projects of type "exhibition" may have artworks that have artists
  const projectArtworks = projectCollection.filter( c => c.typeHandle === "artwork")
  // reduce to a list that is ready to use for the artist card widget
  const projectArtworksArtists = projectArtworks.reduce( (result, artwork) => {
    const artists = artwork?.relatedPeople?.[0]?.members || [] 
    // console.log (artwork, artists) 
    const items = artists.map( artist => ({
      name: artist.title,
      title: artwork.title,
      slug: artwork.slug
    }))
    return result.concat(items)
    }, []
  )

  // projects of type "film installation" may have other projects
  const projectProjects = projectCollection.filter( c => c.typeHandle === "project")
  // prepare for exhibition card widget
  const exhibitionCards = projectProjects.sort(sortEvents) || []


  const sideWidgets = project?.relatedWidgets || []

  // console.log(projectCollection, projectArtworks, projectProjects)

</script>

<div class="container">

  <section class="main">

    <CardMainContent
      category={category}
      category_link={category_link}
      title={teaser}
      subtitle={ title }
      noshare
    > 
      <div slot="headercontent">
        <EventDate {startDate} {endDate} overrideString={dateDisplay}/>
      </div>
      <Body {body} />
    </CardMainContent>

    {#if projectArtworksArtists.length > 0}
      <div class="artists">
        <CardArtists data={projectArtworksArtists} />
      </div>
    {/if}

    {#if exhibitionCards.length > 0}
      <div class="projects">
        {#each exhibitionCards as card}
          <div class="project">
            <CardProjectEvent
              event={card}
            />
          </div>
        {/each}
      </div>
    {/if}

    <Related data={project} />

  </section>

  <aside class="side">
    <SideGroup widgets={sideWidgets} />
  </aside>

</div>

<style lang="scss">
  .container {
    @include grid-padding;
    @include media-2col {
      @include grid;
    }
  }

  .header {
    grid-column: 1 / span 9;
  }
  .main {
    grid-column: 1 / span 9;
    grid-row: 2;
  }

  .side {
    grid-column: 10 / span 3;
    grid-row: 2;
  }

  code {
    grid-row: 3;
    white-space: pre;
  }

  .artists, .projects {
    margin-top: 20px;

    .project {
      margin-bottom: 20px;
    }
  }

  li, a {
    @include typo-grotesk-text-24;
  }

</style>